<template>
  <v-col
    v-if="widgetComponent"
    cols="12"
    :sm="widget.type === 'suggestion' ? 6 : 12"
    class="widget-col"
  >
    <component
      :is="widgetComponent"
      :data="widget.data"
      v-on="$listeners"
    />
  </v-col>
</template>

<script>
import MessageSuggestion from './widgets/MessageSuggestion.vue'

const WIDGET_COMPONENTS = {
  suggestion: MessageSuggestion
}

export default {
  name: 'AiWidget',

  props: {
    widget: {
      type    : Object,
      required: true
    }
  },

  computed: {
    widgetComponent () {
      return WIDGET_COMPONENTS[this.widget?.type] || null
    }
  }
}
</script>

<style scoped>
.widget-col {
  padding: 7px !important;
}
</style>
